(function () {
  "use strict";

  if (window.__pinoAiTrustArticleInitialized) {
    return;
  }

  const root = document.querySelector(".pino-ai-trust-article-root");
  if (!root) {
    return;
  }

  window.__pinoAiTrustArticleInitialized = true;

  const progressBar = root.querySelector("#reading-progress-bar");
  const allowedParams = [
    "utm_id",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "fbclid",
    "gclid"
  ];

  function isSafeParam(value) {
    return value.length <= 200 && !/[\u0000-\u001f\u007f]/u.test(value);
  }

  function preserveCampaignParams() {
    const incoming = new URLSearchParams(window.location.search);

    root.querySelectorAll(".js-product-link").forEach(function (link) {
      const target = new URL(link.href, window.location.href);

      if (target.origin === window.location.origin && target.pathname === "/products/beginner-set") {
        target.pathname = "/pages/beginner-set-lp";
      }

      allowedParams.forEach(function (key) {
        const value = incoming.get(key);
        if (value && isSafeParam(value)) {
          target.searchParams.set(key, value);
        }
      });

      link.href = target.toString();
    });
  }

  function updateProgress() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollable > 0 ? Math.min(1, Math.max(0, scrollTop / scrollable)) : 0;

    if (progressBar) {
      progressBar.style.width = String(progress * 100) + "%";
    }
  }

  let ticking = false;
  function requestUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(function () {
      updateProgress();
      ticking = false;
    });
  }

  preserveCampaignParams();
  updateProgress();
  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate, { passive: true });
}());
